import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

const videos = [
  "IMG_0952.MOV",
  "IMG_0905.MOV",
  "IMG_0890.MOV",
  "IMG_0959.MOV",
  "IMG_0921.MOV",
  "IMG_0860.MOV",
];

function Video() {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const openVideo = (video) => {
    setSelectedVideo(video);
  };

  const closeVideo = () => {
    setSelectedVideo(null);
  };

  return (
    <>
      <Header />

      {/* Page Header Section Start */}
      <div className="page-header bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                  Our video
                </h1>
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>
      {/* Page Header Section End */}
      
      {/* Page Video Gallery Start */}
      <div className="page-video-gallery">
        <div className="container">
          <div className="row">
            {videos.map((video, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                {/* Video Gallery start */}
                <div 
                  className="video-gallery-image wow fadeInUp"
                  data-wow-delay={`${index * 0.1}s`}
                >
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      openVideo(video);
                    }}
                    data-cursor-text="Play"
                  >
                    <figure>
                      <video 
                        src={`/videos/${video}`}
                        muted
                        playsInline
                        preload="metadata"
                        style={{
                          width: '100%',
                          aspectRatio: '1 / 0.829',
                          objectFit: 'cover',
                          borderRadius: '20px'
                        }}
                      />
                    </figure>
                  </a>
                </div>
                {/* Video Gallery end */}
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Page Video Gallery End */}

      {/* Video Modal */}
      {selectedVideo && (
        <div 
          className="video-modal-overlay"
          onClick={closeVideo}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer'
          }}
        >
          <div 
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              width: '90%',
              maxWidth: '1200px',
              cursor: 'default'
            }}
          >
            <button
              onClick={closeVideo}
              style={{
                position: 'absolute',
                top: '-40px',
                right: 0,
                background: 'transparent',
                border: 'none',
                color: '#fff',
                fontSize: '30px',
                cursor: 'pointer',
                zIndex: 10000
              }}
            >
              ×
            </button>
            <video
              src={`/videos/${selectedVideo}`}
              controls
              autoPlay
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '10px'
              }}
            />
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Video;